import { render, staticRenderFns } from "./ContactConversations.vue?vue&type=template&id=e2117e58&scoped=true&"
import script from "./ContactConversations.vue?vue&type=script&lang=js&"
export * from "./ContactConversations.vue?vue&type=script&lang=js&"
import style0 from "./ContactConversations.vue?vue&type=style&index=0&id=e2117e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2117e58",
  null
  
)

export default component.exports